var _rect, _path;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconArchive = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    fill: "rgba(0,0,0,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    opacity: 1,
    d: "M6,7V9H18V7ZM5,11H6v7a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V11h1a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H5A1,1,0,0,0,4,6v4A1,1,0,0,0,5,11Zm3,6V11h8v6Zm3-5a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArchive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-archive.2992a8a2.svg";
export { ForwardRef as ReactComponent };